<template>
    <div class="layout-article d-flex flex-column justify-space-between pa-4" style="height: 100%">
        <app-logo v-if="showLogo" style="height: 4rem; width: 100%; padding: 0 !important" app class="mb-4" />

        <main class="pa-4">
            <slot name="default" />

            <app-divider class="my-8" />

            <app-button
                class="mr-4"
                secondary
                :icon-left="getIcon('back')"
                :text="`${$t('back_to')} ${$t('dashboard')}`"
                :to="{ name: 'Dashboard' }"
            />

            <slot name="footer" />
        </main>
    </div>
</template>

<script>
export default {
    name: 'LayoutArticle',
    components: {
        AppLogo: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppLogo'
            )
    },
    props: {
        showLogo: {
            type: Boolean,
            default: false
        }
    }
};
</script>
<style lang="scss">
.layout-article {
    main {
        width: 67.5rem;
        max-width: 100%;
    }
    p,
    li {
        color: rgba(0, 0, 0, 0.65);
        margin-bottom: 0.5rem;
    }
    .subtitle {
        font-size: 1.2rem;
        font-weight: bold;
        font-style: italic;
        color: rgba(0, 0, 0, 0.44);
    }
}
</style>
